import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {Tooltip} from 'react-tooltip';
import { images } from '../../constants';

import { AppWrap, MotionWrap } from '../../wrapper';
import './Skills.scss';

const SkillsTo = [
  
  {
    name:"Redux",
    bgColor:'#222',
    icon:images.redux
  },
  {
    name:"React JS",
    bgColor:'#f1f1f1',
    icon:images.react
  },
  {
    name:"JavaScript",
    bgColor:'#3498db',
    icon:images.javascript
  },
  {
    name:"CSS",
    bgColor:'#DC143C',
    icon:images.css
  },
  {
    name:"git",
    bgColor:'#222',
    icon:images.git
  },
];

const ExperiencesTo = [
  {
    year: 2022,
    works:[
      {
        companyName:"Pona",
        jobTitle:"Software Engineer Internship",
        description:"I had had a internship at KSA "
      }
    ]
  },
];

const Skills = () => {
  /* const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);

  setSkills(SkillsTo);
  setExperiences(ExperiencesTo); */

  return (
    <>
      <h2 className="head-text">Skills & Experiences</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {SkillsTo.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {ExperiencesTo.map((experience) => (
            <motion.div
              className="app__skills-exp-item"
              key={experience.year}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {experience.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.companyName}
                      key={work.companyName}
                    >
                      <h4 className="bold-text">{work.companyName}</h4>
                      <p className="p-text">{work.jobTitle}</p>
                    </motion.div>
                    <Tooltip
                      id={work.companyName}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.description}
                    </Tooltip>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg',
);